export default __webpack_public_path__ + "static/media/flower_img_top_schedule.03c8cce6.png";